<fury-page-layout mode="card">
    <fury-page-layout-header>
      <div class="headFlex">
        <fury-breadcrumbs [@fadeInRight]  current="Email Template"></fury-breadcrumbs>
        <button mat-button [routerLink]="['/settings/email-template/edit-email-template']" class="sub-button"><span>Edit Template</span></button>
      </div>
     
    </fury-page-layout-header>
    <fury-page-layout-content [@fadeInUp]>
      <div fxLayout="column" fxLayoutAlign="start center">
        <div [@fadeInUp] class="card">
            <p *ngIf="isLoading">Please wait...</p>
            <div *ngIf="!isLoading">
                <!-- <div class="contentprt">
                    <img [src]="emailTemplateData?.image" alt="emailTemplateImage">
                </div> -->
                <div class="contentprt">
                    <img [src]="emailTemplateData?.image" alt="emailTemplateImage">
                    <h3>Image Link</h3>
                    <a [href]="emailTemplateData?.imageLink" target="_blank">{{emailTemplateData?.imageLink}}</a>
                </div>
                <div class="contentprt">
                  <h3>Sender and Receiver Details</h3>
                  <div class="mailwrap">
                  <span>
                    <mat-label class="matlabel">Sender Name</mat-label>
                    <div [innerHTML]="emailTemplateData?.senderName" class="cont"></div>
                  </span>
                  
                    <span>
                      <mat-label class="matlabel">Sender Email</mat-label>
                      <div [innerHTML]="emailTemplateData?.sentEmailFrom" class="cont"></div>
                    </span>
                    <span>
                      <mat-label class="matlabel">Receiver Email</mat-label>
                      <div [innerHTML]="emailTemplateData?.replyToAddress" class="cont"></div>
                    </span>
                  </div>
                  
                  
                  
                </div>

                <div class="contentprt">
                    <h3>Above Image Text</h3>
                    <div [innerHTML]="emailTemplateData?.aboveImageText"></div>
                </div>
                <div class="contentprt">
                    <h3>Below Image Text</h3>
                    <div [innerHTML]="emailTemplateData?.belowImageText"></div>
                </div>
                <div class="contentprt">
                    <h3>Bottom Text</h3>
                    <div [innerHTML]="emailTemplateData?.bottomText"></div>
                </div>
            </div>
        </div>
      </div>
    </fury-page-layout-content>
  </fury-page-layout>
  
  
  
   
  
  
  
